import styled from 'styled-components';

import { CardItem } from 'src/app/components/Elements/Card';

export const StoreInfoContainer = styled(CardItem)`
  display: flex;
  flex-direction: row;
  padding: 0 !important;
`;

export const StoreInfoRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const LeftSpan = styled.span`
  flex-basis: 40%;
  text-align: right;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  color: ${props => props.theme.colors.capsuleGreen60} !important;

  font-size: ${props => props.theme.fontSizes.body} !important;
  ${props => props.theme.mediaQueries.smallDown} {
    font-size: ${props => props.theme.fontSizes.small} !important;
  }
`;

export const RightSpan = styled.span`
  flex-basis: 60%;
  padding-left: ${props => props.theme.space['2.0']};
  padding-bottom: ${props => props.theme.space.s3};

  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;

  font-size: ${props => props.theme.fontSizes.body} !important;
  ${props => props.theme.mediaQueries.smallDown} {
    font-size: ${props => props.theme.fontSizes.small} !important;
  }
`;
